import { TipoContrato } from '../../components/types';
import { BaseResourceModel } from '../../models/base-resource.model';
import { Orgao } from '../comum/orgao.model';
import { LicitacaoAudesp } from '../licitacao/licitacao-audesp.model';
import { Licitacao } from '../licitacao/licitacao.model';
import { TipoContratacao } from '../licitacao/tipo-contratacao.model';
import { ContratoItem } from './contrato-item.model';
import { ContratoResponsavel } from './contrato-responsavel.model';
import { Favorecido } from './favorecido.model';
import { Prazo } from './prazo.model';

export class Contrato extends BaseResourceModel {
  constructor(
    public id?: number,
    public numero?: string,
    public ano?: number,
    public data_assinatura?: Date,
    public data_inicio?: Date,
    public data_termino?: Date,
    public data_contabilizacao?: Date,
    public processo?: string,
    public gestor_exige?: boolean,
    public gestor?: string,
    public gestor_cpf?: string,
    public gestor_cargo?: string,
    public tipo_contrato?: TipoContrato,
    public tipo?: 'CONTRATO' | 'REGISTRO_PRECO',
    public objeto?: string,
    public aditivo?: number,
    public valor_contrato?: number,
    public valor_garantia?: number,
    public valor_caucao?: number,
    public enviar_email?: boolean,
    public parente?: Contrato,
    public licitacao?: Licitacao,
    public orgao?: Orgao,
    public favorecido?: Favorecido,
    public prazo?: Prazo,
    public tipo_contratacao?: TipoContratacao,
    public licitacao_audesp?: LicitacaoAudesp,
    public licitacao_audesp_obra?: LicitacaoAudesp,
    public itens?: ContratoItem[],
    public responsaveis?: ContratoResponsavel[],
    public selecionado?: boolean,
  ) {
    super();
  }
  static converteJson(json: any): Contrato {
    return Object.assign(new Contrato(), json);
  }
}
